import React, { useMemo } from 'react';
import EmptyState, {
  EmptyBody,
  EmptyStateLayoutType,
  EmptyStateProps,
  EmptyTitle,
} from './EmptyState';
import cx from 'classnames';
import { assetUrl } from '~/helpers';
import {
  FilteredTagsProps,
  getTagNames,
} from '../../Tags/Components/TagFilter/hooks/useFilteredTags';
import ManualUploadButton from './ManualUploadButton';
import CollectResponsesButton from './CollectResponsesButton';
import { useHistory } from 'react-router';
import { useZiggy } from '~/react-hooks/use-ziggy';

export type EmptyResponseProps = Pick<EmptyStateProps, 'layout' | 'className'> &
  FilteredTagsProps;

export default function EmptyResponse({
  layout = EmptyStateLayoutType.full,
  className,
  tags = [],
  clearTags,
}: EmptyResponseProps) {
  const history = useHistory();
  const { route } = useZiggy();

  const handleTagsClearClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    clearTags?.();

    history.push(route('projects::assets::all', {}, false));
  };

  const { title, body } = useMemo(() => {
    const title = (
      <EmptyTitle
        noun='testimonial response'
        tagNames={tags.length > 0 ? getTagNames(tags) : undefined}
      />
    );

    const body = (
      <EmptyBody
        variant={tags.length > 0 ? 'tagged' : 'default'}
        layout={layout}
        noun='testimonial response'
        defaultBody='Request testimonials from your customers or upload existing'
        onYourLibraryClick={handleTagsClearClick}
      />
    );

    return {
      title,
      body,
    };
  }, [tags, layout]);

  const blockLayout = layout === EmptyStateLayoutType.block;

  const buttons = (
    <div
      className={cx('flex gap-2', {
        'flex-col': blockLayout,
      })}
    >
      <ManualUploadButton
        text='Upload testimonials'
        className={cx({
          'w-full justify-center': blockLayout,
        })}
      />
      <CollectResponsesButton
        className={cx({
          'w-full': blockLayout,
        })}
      />
    </div>
  );

  return (
    <EmptyState
      layout={layout}
      className={className}
      imageUrl={assetUrl('assets/images/video-library/response.png')}
      title={title}
      body={body}
      actions={buttons}
    />
  );
}
